// extracted by mini-css-extract-plugin
module.exports = {"alignCenter":"MonthlyChangeSection_alignCenter__rORsA","section":"MonthlyChangeSection_section__e_d06","border":"MonthlyChangeSection_border__LK8Ie"};